<script>
  import {getRandomInt} from '@/modules/helper/index'
  import { mapGetters } from "vuex";
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      options: {
        type: Array,
        default: [],
        required: true
      },
      hasDefault: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ''
      },
      index: {
        type: Number,
        default: ''
      },
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        selectedValue: null,
        pickerelement: null
      }
    },
    computed: {
      ...mapGetters(["resource"]),
      randomNo() {
        return getRandomInt()
      },
      pickerId() {
        return 'picker-list-' + this.randomNo
      },
      defaultValue() {
        return this.value === null ? this.selectedValue : this.value
      }
    },
    mounted() {
      this.setDefaultValue()
      this.createListpicker()
    },
    watch: {
      options: function(value, oldvalue) {
       //  console.log('options watch', value, oldvalue)
        if (value.length !== oldvalue.length && this.pickerelement) {
          this.pickerelement.destroy()
          this.pickerelement = null
        }
        this.setDefaultValue()
        this.createListpicker()
      }
    },
    methods: {
      createListpicker() {
        let $this = this
        if (this.pickerelement === null) {
          this.pickerelement = this.$f7.picker.create({
            inputEl: '#' + this.pickerId,
            rotateEffect: true,
            openIn: 'sheet',
            toolbarCloseText: this.resource.closeBtn,
            routableModals:false,
            value: this.defaultValue === null ? '' : [this.defaultValue],
            on: {
              change: function(picker, values, displayValues) {
                // if ($this.hasDefault && $this.value === null) {
                  $this.$emit('propChange', { value: values[0] })
                // }
              },
              close: function(picker) {
                // console.log('onClose picker', picker)
                $this.$emit('propChange', { value: picker.value[0] })
              }
            },
            cols: [
              {
                textAlign: 'center',
                values: (function() {
                  var arr = []
                  for (let _option of $this.options) { arr.push(_option.text) }
                  return arr
                })()
              }
            ]
          })
          // console.log('this.pickerelement', this.pickerelement)
        }
      },
      setDefaultValue() {
        if (this.hasDefault && this.value === null) {
          for (let _option of this.options) {
            if (_option.default) {
              this.selectedValue = _option.text
            }
          }
        } else {
          this.selectedValue = null
        }
      }
    },
    beforeDestroy() {
      // console.log('beforeDestroy', this.pickerelement)
      if (this.pickerelement) {
        this.pickerelement.destroy()
      }
    }
  }
</script>
<template>
  <f7-list class="action-list inputs-list">
    <f7-list-item class="input-wrapper">
      <f7-label class="label-color">{{label}}</f7-label>
      <f7-input type="text" :placeholder="placeholder" :id="pickerId" v-model="defaultValue" class="input-value-color" :readonly="true"></f7-input>
    </f7-list-item>
  </f7-list>
</template>
<style scoped>
  .list {
    margin: 15px 0;
  }
  .item-label {
    line-height: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/PickerList.vue